import request from "@assets/js/axios";
const { instance: $axios } = request;
class Coupon {
  constructor() {}
  use (params) {
    return $axios.get('/mycoupon/ableByorder', { params });
  }
}

export default new Coupon();